// The Overview's recommendations as the decisions a future state is generated from (see EpmFutureStateService): each
// becomes a decision with the scorecard's lever closest to it, what it found as the signal, its evidence as the
// rationale, and the roles, systems, steps and outputs it is about, as the evidence names them
import { EpmDecisionEvidence, EpmFutureStateDecision, EpmLever, EpmNodeKind } from '../common/epm-decisions';
import { Recommendation, RecommendationLever } from './recommendations';

// the scorecard lever that carries out each kind of recommendation
const LEVERS: Record<RecommendationLever, EpmLever> = {
    capacity: 'protect',        // staff the role, or move work off it
    automate: 'automate',
    integrate: 'automate',      // a system takes the information in, rather than people
    digitise: 'automate',       // the step is done in a system
    eliminate: 'eliminate',
    protect: 'protect',
    value: 'amplify',
    service: 'automate',        // a system makes the step easier for those outside who do it
    data: 'investigate',
};

const same = (a: string | undefined, b: string) => !!a && a.trim().toLowerCase() === b.trim().toLowerCase();

// what kind of node a name is, as the evidence has it; a name it doesn't have is taken as a step
const kindOf = (name: string, evidence: EpmDecisionEvidence): EpmNodeKind => {
    if ((evidence.roles || []).some(r => same(r.name, name))) return 'role';
    if ((evidence.systems || []).some(s => same(s.name, name))) return 'system';
    if ((evidence.outputs || []).some(o => same(o.name, name))) return 'info';
    return 'action';
};

export const recommendationDecision = (r: Recommendation, evidence: EpmDecisionEvidence): EpmFutureStateDecision => ({
    title: r.title,
    lever: LEVERS[r.lever],
    signal: r.detail,
    rationale: [r.why, ...r.evidence].filter(x => !!x).join(' '),
    nodes: [...new Set(r.subjects)].map(name => ({ kind: kindOf(name, evidence), name })),
});
